import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useExecutiveDashboardTitleStyles = makeThemedStyles(
  "ExecutiveDashboardTitle",
  (theme) => ({
    root: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      fontSize: "18px",
      fontWeight: 500,
      color: "#444",
      marginTop: "30px",
      marginBottom: "10px",
    },
  })
);

const ExecutiveDashboardTitle = (props: React.PropsWithChildren<{}>) => {
  const styles = useExecutiveDashboardTitleStyles();
  return <div className={styles.root}>{props.children}</div>;
};

export default ExecutiveDashboardTitle;
